export const chatConstants = {
    TOGGLE_POPUP: 'CHAT_TOGGLE_POPUP',
    TOGGLE_POPUP_ANSWER: 'CHAT_TOGGLE_POPUP_ANSWER',

    TOGGLE_SLIDE: 'CHAT_TOGGLE_SLIDE',

    SEND_REQUEST: 'CHAT_SEND_REQUEST',
    SEND_SUCCESS: 'CHAT_SEND_SUCCESS',
    SEND_FAILURE: 'CHAT_SEND_FAILURE',

    RECEIVE_REQUEST: 'CHAT_RECEIVE_REQUEST',
    RECEIVE_SUCCESS: 'CHAT_RECEIVE_SUCCESS',
    RECEIVE_FAILURE: 'CHAT_RECEIVE_FAILURE',

    LOAD_REQUEST: 'CHAT_LOAD_REQUEST',
    LOAD_SUCCESS: 'CHAT_LOAD_SUCCESS',
    LOAD_FAILURE: 'CHAT_LOAD_FAILURE',

    DELETE_REQUEST: 'CHAT_DELETE_REQUEST',
    DELETE_SUCCESS: 'CHAT_DELETE_SUCCESS',
    DELETE_FAILURE: 'CHAT_DELETE_FAILURE',
}
